import { MatPaginatorIntl } from '@angular/material/paginator';

export class ItaPaginatorIntl extends MatPaginatorIntl {

  private totalCapped = false;

  constructor() {
    super();

    this.itemsPerPageLabel = 'Elementi per pagina:';
    this.nextPageLabel = 'Pagina successiva';
    this.previousPageLabel = 'Pagina precedente';
    this.lastPageLabel = 'Ultima pagina';
    this.firstPageLabel = 'Prima pagina';
  }

  // MatPaginatorIntl dichiara getRangeLabel come proprietà, non come metodo
  getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length == 0 || pageSize == 0) {
      return `0 su ${length}`;
    }

    length = Math.max(length, 0);

    const startIndex = page * pageSize;

    // If the start index exceeds the list length, do not try and fix the end index to the end.
    const endIndex =
      startIndex < length
        ? Math.min(startIndex + pageSize, length)
        : startIndex + pageSize;

    if (this.totalCapped) {
      return `${startIndex + 1} - ${endIndex} di oltre ${length}+`;
    }

    return `${startIndex + 1} - ${endIndex} su ${length}`;
  }

  /**
   * Il backend limita il conteggio (meta.total_capped) per evitare COUNT(*) inefficienti:
   * in quel caso il totale è un minimo e la label lo esplicita.
   */
  setTotalCapped(capped: boolean): void {
    if (this.totalCapped === capped) return;
    this.totalCapped = capped;
    this.changes.next();
  }
}


export function getItaPaginatorIntl(): ItaPaginatorIntl {
  return new ItaPaginatorIntl();
}
